<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>Review Details</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <div class="reviewdetail">
            <div *ngIf="!loading">
                <div class="feedbacklist">
                    <ul>
                        <li *ngIf="reviewDetails?.feedback"><label>Feedback:</label><span>{{reviewDetails?.feedback}}</span></li>
                        <li><label>Browser Id:</label><span>{{reviewDetails?.browserId}}</span></li>
                        <li><label>Ip Address:</label> <span>{{reviewDetails?.ipAddress}}</span></li>
                        <li><label>Review Status:</label> <span>{{reviewDetails?.reviewStatus}}</span></li>
                        <li><label>First Name:</label> <span>{{reviewDetails?.reviewDetails?.firstName}}</span></li>
                        <li><label>Last Name:</label> <span>{{reviewDetails?.reviewDetails?.lastName}}</span></li>
                        <li><label>Email Address:</label> <span>{{reviewDetails?.reviewDetails?.emailAddress}}</span></li>
                        <li><label>Phone No:</label> <span>{{reviewDetails?.reviewDetails?.phoneNumber}}</span></li>
                        <li><label>Customer Experience:</label> <span>{{reviewDetails?.reviewDetails?.customerExperience}}</span></li>
                        <li><label>CustomerSuggestions:</label> <span>{{reviewDetails?.reviewDetails?.customerSuggestions}}</span></li>
                    </ul>
                </div>
            </div>
            <div *ngIf="loading">Please Wait...</div>
        </div>
    </div>
  </div>
  

